import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './http'
// vant
import Vant from 'vant'
import 'vant/lib/index.css'
// 重置css
import './assets/styles/reset.css'
// 1像素边框样式
import './assets/styles/border.css'
// iconfont
import './assets/styles/iconfont.css'

Vue.use(Vant)
// 将axios挂载到prototype上，在组件中可以直接使用this.axios访问
Vue.prototype.axios = axios

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
